import React, { useCallback, useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import {
  getRewardCalcSetting,
  updateRewardCalcSetting,
} from "../controller/api/rewardCalcJob";
import { Routes } from "../routes";

const DEFAULT_AUTO_GAMES = {
  keno: false,
  mega: false,
  power: false,
  max3d: false,
  max3dpro: false,
  lotto535: false,
};

const DEFAULT_AUTO_PAY_GAMES = {
  keno: false,
  mega: false,
  power: false,
  max3d: false,
  max3dpro: false,
  lotto535: false,
};

const RewardCalcAutoToggle = ({ gameId, gameName }) => {
  const [cookies] = useCookies(["lottmekong"]);
  const token = cookies.lottmekong;

  const [autoGames, setAutoGames] = useState(DEFAULT_AUTO_GAMES);
  const [autoPayGames, setAutoPayGames] = useState(DEFAULT_AUTO_PAY_GAMES);
  const [concurrency, setConcurrency] = useState(2);
  const [savingSetting, setSavingSetting] = useState(false);

  const fetchSetting = useCallback(async () => {
    const config = await getRewardCalcSetting(token);
    if (config) {
      setAutoGames({ ...DEFAULT_AUTO_GAMES, ...config.autoGames });
      setAutoPayGames({
        ...DEFAULT_AUTO_PAY_GAMES,
        ...config.autoPayGames,
      });
      setConcurrency(config.concurrency);
    }
  }, [token]);

  useEffect(() => {
    fetchSetting();
  }, [fetchSetting]);

  const saveSetting = async (nextAutoGames, nextAutoPayGames) => {

    setSavingSetting(true);
    try {
      const config = await updateRewardCalcSetting(
        token,
        nextAutoGames,
        nextAutoPayGames,
        concurrency
      );
      if (config) {
        setAutoGames({ ...DEFAULT_AUTO_GAMES, ...config.autoGames });
        setAutoPayGames({
          ...DEFAULT_AUTO_PAY_GAMES,
          ...config.autoPayGames,
        });
        setConcurrency(config.concurrency);
        toast.success("Đã lưu cấu hình tính thưởng");
      } else {
        toast.error("Không thể lưu cấu hình tính thưởng");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Không thể lưu cấu hình tính thưởng"
      );
    } finally {
      setSavingSetting(false);
    }
  };

  const onToggleAuto = () => {
    saveSetting(
      { ...autoGames, [gameId]: !autoGames[gameId] },
      autoPayGames
    );
  };

  const onToggleAutoPay = () => {
    saveSetting(
      autoGames,
      { ...autoPayGames, [gameId]: !autoPayGames[gameId] }
    );
  };

  return (
    <Card border="light" className="shadow-sm mb-4">
      <Card.Body className="py-3">
        <Row className="align-items-center">
          <Col>
            <h5 className="mb-0">Tính thưởng tự động {gameName}</h5>
            <small className="text-muted d-block mb-2">
              Tự động tính sẽ tạo job khi có kết quả; tự động trả sẽ cộng tiền
              vào ví thưởng của vé trúng.
            </small>
            <Button
              as={Link}
              to={`${Routes.VietlottRewardCalcJob.path}?gameId=${encodeURIComponent(gameId)}`}
              variant="outline-secondary"
              size="sm"
            >
              Xem danh sách job
            </Button>
          </Col>
          <Col xs="auto" className="d-flex align-items-center gap-4">
            <Form.Check
              type="switch"
              id={`reward-calc-auto-${gameId}`}
              label={`Tự động tính: ${autoGames[gameId] ? "Bật" : "Tắt"}`}
              checked={autoGames[gameId]}
              onChange={onToggleAuto}
              disabled={savingSetting}
            />
            <Form.Check
              type="switch"
              id={`reward-pay-auto-${gameId}`}
              label={`Tự động trả: ${autoPayGames[gameId] ? "Bật" : "Tắt"}`}
              checked={autoPayGames[gameId]}
              onChange={onToggleAutoPay}
              disabled={savingSetting || gameId === "lotto535"}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default RewardCalcAutoToggle;
